'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  border-bottom: 1px solid ', ';\n  padding: 1em 2em;\n  font-size: 1.2em;\n  display: block;\n  color: ', '\n\n  &:hover {\n    text-decoration: none;\n    background-color: ', '\n  }\n'], ['\n  border-bottom: 1px solid ', ';\n  padding: 1em 2em;\n  font-size: 1.2em;\n  display: block;\n  color: ', '\n\n  &:hover {\n    text-decoration: none;\n    background-color: ', '\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n'], ['\n  width: 100%;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MozartDrawer = require('./../MozartDrawer/MozartDrawer');

var _MozartDrawer2 = _interopRequireDefault(_MozartDrawer);

var _MozartIcon = require('./../MozartIcon/MozartIcon');

var _MozartIcon2 = _interopRequireDefault(_MozartIcon);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Item = _styledComponents2.default.a(_templateObject, _color2.default.purple_main, _color2.default.blue_main, _color2.default.purple_accent);

var Container = _styledComponents2.default.div(_templateObject2);

var BodyContainer = _styledComponents2.default.div(_templateObject2);

var MozartHamburger = function (_Component) {
  _inherits(MozartHamburger, _Component);

  function MozartHamburger(props) {
    _classCallCheck(this, MozartHamburger);

    var _this = _possibleConstructorReturn(this, (MozartHamburger.__proto__ || Object.getPrototypeOf(MozartHamburger)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(MozartHamburger, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          width = _props.width,
          data = _props.data,
          themeId = _props.themeId;

      return _react2.default.createElement(
        Container,
        { style: style, 'data-theme': themeId },
        _react2.default.createElement(_MozartDrawer2.default, {
          title: '',
          data: _react2.default.createElement(
            BodyContainer,
            null,
            data.map(function (item) {
              return _react2.default.createElement(
                Item,
                { onClick: item.onClick },
                item.itemData
              );
            })
          ),
          width: width,
          bodyStyle: { padding: '0' },
          node: _react2.default.createElement(_MozartIcon2.default, { data: _react2.default.createElement('span', { className: 'icon-Hamburger' }) })
        })
      );
    }
  }]);

  return MozartHamburger;
}(_react.Component);

MozartHamburger.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** style override */
  style: _propTypes2.default.object,
  /** width container */
  width: _propTypes2.default.string,
  /** Array of object {name, href} */
  data: _propTypes2.default.array.isRequired
};
MozartHamburger.defaultProps = {
  testId: 'MozartHamburger',
  themeId: 'MozartHamburger',
  width: '350px',
  data: []
};
exports.default = MozartHamburger;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartHamburger/MozartHamburger.js
// module id = 2117
// module chunks = 1